module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"all":"All"}}')
  delete Component.options._Ctor
}
